import './Locations.css';

function Ski () {
  return (
    <div className="Table">
      <table>
          <tr>
          <th></th>
          <th>a</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th>big</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th>snake</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>along</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>the</th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>width</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th>of</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th>the</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th>mountain.</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th>Back</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th>and</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th>forth</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th>they</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>fly</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>down</th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>the</th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>hill</th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>so</th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>fast</th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>Cyane</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th></th>
          <th>begins</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th></th>
          <th>to</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>

          <tr>
          <th>soar.</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          </tr>
        </table>
    </div>
  )
}

export default Ski;